<template>
  <div class="notification-list-skeleton">
    <div v-for="i in count" :key="'skeleton-item-' + i" class="skeleton-item">
      <div class="skeleton-shimmer skeleton-checkbox"></div>
      <div class="skeleton-shimmer skeleton-icon"></div>
      <div class="skeleton-content">
        <div class="skeleton-shimmer skeleton-line skeleton-line--title"></div>
        <div class="skeleton-shimmer skeleton-line skeleton-line--sub"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationListSkeleton",
  props: {
    count: {
      type: Number,
      default: 6,
    },
  },
};
</script>

<style scoped>
@keyframes skeleton-shimmer-anim {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-shimmer {
  display: block;
  border-radius: 4px;
  background: linear-gradient(90deg, #eee 25%, #e5e5e5 50%, #eee 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer-anim 1.5s infinite;
}

.notification-list-skeleton {
  padding: 0;
}

.skeleton-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.skeleton-checkbox {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  flex-shrink: 0;
}

.skeleton-icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  flex-shrink: 0;
}

.skeleton-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-line {
  height: 14px;
  border-radius: 4px;
}

.skeleton-line--title {
  width: 75%;
}

.skeleton-line--sub {
  width: 45%;
  height: 12px;
}

@media (max-width: 480px) {
  .skeleton-item {
    padding: 12px;
    gap: 10px;
  }

  .skeleton-icon {
    width: 32px;
    height: 32px;
  }
}

@media (max-width: 768px) {
  .skeleton-item {
    min-height: 64px;
    box-sizing: border-box;
    padding: 12px;
  }

  .skeleton-checkbox {
    width: 20px;
    height: 20px;
  }

  .skeleton-icon {
    width: 40px;
    height: 40px;
  }
}
</style>
